module.exports = __webpack_public_path__ + "img/lock.14a2cef0.svg";